// Re-exports react-native-web and adds type-only stubs that have no runtime value.
// StyleProp is a TypeScript type in @types/react-native but is not exported by
// react-native-web. Some react-native packages import it as a value — this stub
// prevents webpack from erroring on those imports.
export * from 'react-native-web'
export const StyleProp = undefined
